var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserlocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8b8c8b;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,50c0-12.4-4.5-23.7-11.9-32.4L99.5,6.2l-5.7-5.7L82.4,11.9C73.7,4.5,62.4,0,50,0 C37.6,0,26.3,4.5,17.6,11.9L6.2,0.5L0.5,6.2l11.4,11.4C4.5,26.3,0,37.6,0,50c0,12.4,4.5,23.7,11.9,32.4L0.5,93.8l5.7,5.7l11.4-11.4 c8.7,7.4,20,11.9,32.4,11.9s23.7-4.5,32.4-11.9l11.4,11.4l5.7-5.7L88.1,82.4C95.5,73.7,100,62.4,100,50z M50,92 c-10.1,0-19.5-3.6-26.7-9.6l11.2-11.2l-5.7-5.7L17.6,76.7C11.6,69.5,8,60.1,8,50s3.6-19.5,9.6-26.7l11.2,11.2l5.7-5.7L23.3,17.6 C30.5,11.6,39.9,8,50,8s19.5,3.6,26.7,9.6L65.6,28.8l5.7,5.7l11.2-11.2c6,7.3,9.6,16.6,9.6,26.7s-3.6,19.5-9.6,26.7L71.2,65.6 l-5.7,5.7l11.2,11.2C69.5,88.4,60.1,92,50,92z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserlocation);
export default __webpack_public_path__ + "static/media/userlocation.4939183c.svg";
export { ForwardRef as ReactComponent };